<template>
  <v-card>
    <v-card id="working_drawer_height">
      <v-card-text class="pa-1">
        <v-row align="center" justify="space-between" class="mr-1 ml-1">
          <h3 v-if="curDrawerType === 'schedule'">待批阅场次</h3>
          <h3 v-else-if="curDrawerType === 'student'">待批阅学生</h3>
          <user-menu></user-menu>
        </v-row>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-row align="center" justify="center" class="mr-0 ml-0">
          <v-btn-toggle v-model="filter" class="d-flex flex-wrap">
            <v-col cols="4" class="pa-0">
              <v-btn text height="32" value="all" class="pa-1">
                {{ `全部(${allCount})` }}
              </v-btn>
              <v-btn text height="32" value="draft" class="pa-1">
                {{ `草稿(${draftCount})` }}
              </v-btn>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-btn text height="32" value="submit" class="pa-1">
                {{ `待批阅(${submitCount})` }}
              </v-btn>
              <v-btn text height="32" value="sendback" class="pa-1">
                {{ `已退回(${sendbackCount})` }}
              </v-btn>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-btn text height="32" value="reviewed" class="pa-1">
                {{ `已批阅(${reviewedCount})` }}
              </v-btn>
            </v-col>
          </v-btn-toggle>
        </v-row>
      </v-card-text>
      <v-card-actions id="WorkingDrawerCardActions">
        <v-container class="pa-0">
          <v-row class="mb-2" align="center" no-gutters>
            <v-col cols="5">
              <v-checkbox
                v-if="filter === 'draft'"
                v-model="selectAll"
                class="mt-0"
                label="全选"
                hide-details
                required
                @change="check"
              ></v-checkbox>
            </v-col>
            <v-col cols="5">
              <v-btn
                v-if="filter === 'draft'"
                height="30"
                color="warning"
                class="mt-0"
                @click="submit"
              >
                提交
                <v-icon right dark>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <v-col cols="5">
              <v-btn
                height="30"
                color="primary"
                class="mt-0"
                @click="openTodoDrawer('student')"
              >
                按学生
                <v-icon right dark>mdi-menu</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn
                height="30"
                color="primary"
                class="mt-0"
                @click="openTodoDrawer('schedule')"
              >
                按场次
                <v-icon right dark>mdi-menu</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <v-card>
      <v-card-text class="pa-0">
        <div
          v-scroll
          v-bar="{
            preventParentScroll: true,
            scrollThrottle: 30
          }"
          :style="workingDrawerHeight"
        >
          <div>
            <v-list
              v-for="(group, index) in groups"
              :key="`group-${index}`"
              two-line
              subheader
            >
              <v-list color="grey" class="pa-1">
                {{ group.name }}
                <br />
                {{
                  `全部(${group.electives.length}) 待批阅(${count(
                    group.electives,
                    'S'
                  )}) 已退回(${count(group.electives, 'Re')}) 草稿(${count(
                    group.electives,
                    'Draft'
                  )})`
                }}
              </v-list>
              <v-list-item-group active-class="primary--text">
                <template v-for="(elective, subIndex) in group.electives">
                  <v-list-item class="pl-2" :key="`d-${subIndex}`">
                    <v-list-item-action
                      v-if="
                        filter === 'draft' &&
                          elective.reports.length > 0 &&
                          elective.reports[0].status === 'Draft'
                      "
                      @click.capture.stop="checkOne(elective)"
                    >
                      <v-checkbox
                        color="primary"
                        v-model="checkboxes"
                        :value="elective.id"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-row
                      @click.capture="select(elective)"
                      class="align-center my-1 no-gutters"
                    >
                      <v-col cols="5" class="pa-0">
                        <div class="text-wrap">
                          <span
                            v-if="curDrawerType === 'schedule'"
                            class="font-weight-medium"
                          >
                            {{ elective.users.name }}
                          </span>
                          <span
                            v-else-if="curDrawerType === 'student'"
                            class="font-weight-medium"
                          >
                            {{
                              isOrg
                                ? `${elective.user_code}`
                                : elective.projects.name
                            }}
                          </span>
                        </div>
                        <div v-if="curDrawerType === 'student' && isOrg">
                          {{ elective.user_name }}
                        </div>
                      </v-col>
                      <v-col
                        cols="7"
                        class="pa-0 d-flex flex-wrap align-center justify-end"
                      >
                        <v-chip
                          v-if="
                            elective.reports.length > 0 &&
                              (elective.reports[0].status === 'Draft' ||
                                elective.reports[0].status === 'C' ||
                                elective.reports[0].status === 'Y')
                          "
                          small
                          label
                          class="mx-1 my-1"
                        >
                          {{
                            `${
                              elective.project_score
                                ? elective.project_score.report_score
                                : 0
                            }分`
                          }}
                        </v-chip>
                        <v-chip
                          v-if="
                            elective.reports.length > 0 &&
                              (elective.reports[0].status === 'C' ||
                                elective.reports[0].status === 'Y')
                          "
                          small
                          label
                          class="mx-1 my-1"
                          color="success"
                        >
                          {{
                            `已批阅: ${
                              elective.reports[0].users
                                ? elective.reports[0].users.name
                                : ''
                            }`
                          }}
                        </v-chip>
                        <v-chip
                          v-else-if="
                            elective.reports.length > 0 &&
                              elective.reports[0].status === 'Draft'
                          "
                          small
                          label
                          class="mx-1 my-1"
                          color="primary"
                        >
                          {{
                            `存草稿: ${
                              elective.reports[0].users
                                ? elective.reports[0].users.name
                                : ''
                            }`
                          }}
                        </v-chip>
                        <v-chip
                          v-else-if="
                            elective.reports.length > 0 &&
                              elective.reports[0].status === 'S'
                          "
                          small
                          label
                          class="mx-1 my-1"
                          color="warning"
                          >{{ `待批阅` }}
                        </v-chip>
                        <v-chip
                          v-else-if="
                            elective.reports.length > 0 &&
                              elective.reports[0].status === 'Re'
                          "
                          small
                          label
                          class="mx-1 my-1"
                          color="error"
                          >{{ `已退回` }}
                        </v-chip>
                        <v-chip
                          v-else-if="
                            elective.att_status === 'att_y' ||
                              elective.att_status === 'att_y_late' ||
                              elective.att_status === 'att_y_unclean' ||
                              (elective.att_status === 'att_n' &&
                                !isTruancy(elective.schedules))
                          "
                          small
                          label
                          class="mx-1 my-1"
                        >
                          未提交
                        </v-chip>
                        <v-chip
                          v-else-if="elective.att_status === 'att_n_leave'"
                          small
                          label
                          class="mx-1 my-1"
                        >
                          已请假
                        </v-chip>
                        <v-chip
                          v-else-if="elective.att_status === 'att_n_unfinished'"
                          small
                          label
                          class="mx-1 my-1"
                        >
                          未完成
                        </v-chip>
                        <v-chip
                          v-else-if="isTruancy(elective.schedules)"
                          small
                          label
                          class="mx-1 my-1"
                        >
                          旷课
                        </v-chip>
                        <v-btn
                          v-if="
                            user.role === 'teacher' &&
                              elective.att_status.startsWith('att_y') &&
                              (elective.reports.length === 0 ||
                                elective.reports[0].status === 'N' ||
                                elective.reports[0].status === 'Re')
                          "
                          small
                          color="warning"
                          class="mx-1 my-1"
                          @click.capture.stop="sendNotification(elective)"
                          >催缴报告</v-btn
                        >
                      </v-col>
                      <v-col cols="12" class="pa-0 pl-1">
                        <div
                          v-if="isDeferCommit(elective)"
                          class="text-center error--text"
                        >
                          <small>
                            {{
                              elective.reports.length > 0 &&
                              elective.reports[0].commit_time
                                ? elective.reports[0].commit_time
                                    .substr(0, 19)
                                    .replace('T', ' ')
                                : ''
                            }}
                            ({{ deferCommit(elective) }} 天)
                          </small>
                        </div>
                        <div v-else class="text-center success--text">
                          <small>
                            {{
                              elective.reports.length > 0 &&
                              elective.reports[0].commit_time
                                ? elective.reports[0].commit_time
                                    .substr(0, 19)
                                    .replace('T', ' ')
                                : ''
                            }}
                          </small>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < group.electives.length"
                    :key="subIndex"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';

import UserMenu from '../components/UserMenu';

export default {
  data() {
    return {
      filter: '',
      selectAll: false,
      checkboxes: [],
      allCount: 0,
      submitCount: 0,
      sendbackCount: 0,
      draftCount: 0,
      reviewedCount: 0,
      semester: '',
      teacher: '',
      experiment: '',
      startMenu: false,
      endMenu: false,
      startDate: null,
      endDate: null,
      workingDrawerHeight: ''
    };
  },
  components: {
    UserMenu
  },
  computed: {
    ...mapGetters([
      'config',
      'user',
      'elective',
      'electives',
      'curDrawerType',
      'isOrg'
    ]),
    groups() {
      let filterGroups = JSON.parse(JSON.stringify(this.electives));

      if (this.filter === 'submit') {
        filterGroups.forEach((g, index) => {
          filterGroups[index].electives = g.electives.filter(
            e => e.reports.length > 0 && e.reports[0].status === 'S'
          );
        });
      } else if (this.filter === 'sendback') {
        filterGroups.forEach((g, index) => {
          filterGroups[index].electives = g.electives.filter(
            e => e.reports.length > 0 && e.reports[0].status === 'Re'
          );
        });
      } else if (this.filter === 'draft') {
        filterGroups.forEach((g, index) => {
          filterGroups[index].electives = g.electives.filter(
            e => e.reports.length > 0 && e.reports[0].status === 'Draft'
          );
        });
      } else if (this.filter === 'reviewed') {
        filterGroups.forEach((g, index) => {
          filterGroups[index].electives = g.electives.filter(
            e =>
              e.reports.length > 0 &&
              (e.reports[0].status === 'C' || e.reports[0].status === 'Y')
          );
        });
      }

      return filterGroups;
    }
  },
  watch: {
    groups() {
      // 更新待批阅统计
      this.allCount = 0;
      this.submitCount = 0;
      this.sendbackCount = 0;
      this.draftCount = 0;
      this.reviewedCount = 0; // 新增已批阅计数
      this.electives.forEach(g => {
        // 默认加载一个待批阅学生报告
        if (!this.elective) {
          let target = g.electives.find(
            e =>
              e.reports.length > 0 &&
              (e.reports[0].status === 'S' || e.reports[0].status === 'Draft')
          );
          if (target) {
            // this.changeElective(target);
          }
        }
        g.electives.forEach(e => {
          if (e.reports.length > 0 && e.reports[0].status === 'S') {
            this.submitCount++;
          } else if (e.reports.length > 0 && e.reports[0].status === 'Re') {
            this.sendbackCount++;
          } else if (e.reports.length > 0 && e.reports[0].status === 'Draft') {
            this.draftCount++;
          } else if (
            e.reports.length > 0 &&
            (e.reports[0].status === 'C' || e.reports[0].status === 'Y')
          ) {
            this.reviewedCount++; // 统计已批阅数量
          }
          this.allCount++;
        });
      });
      this.checkboxes = [];
    }
  },
  mounted() {
    this.filter = 'all';
    this.getWorkingDrawerHeight();
  },
  methods: {
    ...mapActions([
      'updateReportStatus',
      'changeElective',
      'reloadElective',
      'sendNotification',
      'selectDrawerType',
      'alert'
    ]),
    count(electives, filter) {
      return electives.filter(
        e => e.reports.length > 0 && e.reports[0].status === filter
      ).length;
    },
    isTruancy(schedule) {
      if (schedule) {
        let ctime = Date.parse(new Date());
        let ltime = Date.parse(schedule.date + ' ' + schedule.periods.end_time);

        if (ctime > ltime) {
          return true;
        }
      }
      return false;
    },
    formatTime(time) {
      if (time) {
        return time.slice(0, 16);
      }
      return '';
    },
    openTodoDrawer(type) {
      this.selectDrawerType(type);
      this.$store.commit('toggleTodoDrawer', true);
    },
    isDeferCommit(elective) {
      if (elective.reports.length > 0 && elective.schedules) {
        let end = dayjs(
          elective.schedules.date + ' ' + elective.schedules.periods.end_time
        ).add(this.config.duration, 'day');
        let commit = dayjs(elective.reports[0].commit_time);

        if (commit && commit.isAfter(end)) return true;
        else return false;
      } else return false;
    },
    deferCommit(elective) {
      if (elective.schedules) {
        let end = dayjs(
          elective.schedules.date + ' ' + elective.schedules.periods.end_time
        ).add(this.config.duration, 'day');
        let commit = dayjs(elective.reports[0].commit_time);

        return Math.floor((commit - end) / 1000 / 60 / 60 / 24);
      }
    },
    select(elective) {
      if (
        this.filter !== 'draft' &&
        this.elective &&
        elective.id === this.elective.id
      ) {
        return;
      }
      if (
        elective.reports.length > 0 &&
        (elective.reports[0].status === 'S' ||
          elective.reports[0].status === 'Draft' ||
          elective.reports[0].status === 'C' ||
          elective.reports[0].status === 'Y' ||
          elective.reports[0].status === 'Re')
      ) {
        this.changeElective(elective);
      } else {
        this.alert({ message: '未提交报告', color: 'error' });
        return;
      }
    },
    checkOne(elective) {
      if (this.filter === 'draft') {
        const index = this.checkboxes.findIndex(x => x === elective.id);
        if (index !== -1) {
          this.checkboxes.splice(index, 1);
        } else {
          this.checkboxes.push(elective.id);
        }
      }
    },
    check(checked) {
      const _this = this;
      if (checked) {
        this.groups.forEach(g => {
          g.electives.forEach(e => {
            _this.checkboxes.push(e.id);
          });
        });
      } else {
        this.checkboxes = [];
      }
    },
    submit() {
      if (this.checkboxes.length === 0) {
        this.alert({ message: '未选择要提交的草稿', color: 'error' });
        return;
      }
      const _this = this;
      this.updateReportStatus({
        reports: this.checkboxes,
        status: 'C'
      }).then(() => {
        _this.alert({ message: '报告提交成功', color: 'success' });
        _this.reloadElective();
      });
    },
    getWorkingDrawerHeight() {
      const h =
        document.getElementById('working_drawer_height').offsetHeight + 1;
      this.workingDrawerHeight = 'height: calc(100vh - '.concat(h, 'px);');
    }
  }
};
</script>
